<template>
	<AppLayout :title="trans('admin.periods.events.requests.title')">
		<Pagination :resource="requests"/>
		<Empty v-if="requests.data.length === 0"/>
		<CardGrid v-else>
			<Card
				v-for="request in requests.data"
				:key="`period-request-${request.id}`"
				:title="request.lemma !== null ? `${trans('general.quotes.open')}${request.lemma}${trans('general.quotes.close')}` : request.name"
				:subtitle="`${dayjs(request.begins_on).format(trans('general.dayjs.date'))} - ${dayjs(request.ends_on).format(trans('general.dayjs.date'))}`"
			>
				<template #badges>
					<Badge :color="request.is_accepted ? Color.Green : request.is_rejected ? Color.Red : Color.Orange" active>{{ trans(`admin.periods.requests.status.${request.status}`) }}</Badge>
					<div class="flex items-center gap-2">
						<i v-if="request.online" class="fa-solid fa-video-camera text-gray-500"/>
						<Badge :color="Color.Indigo" active>{{ trans(`events.${request.type}.title`) }}</Badge>
					</div>
				</template>
				<LabeledObject>
					<template #label>{{ trans('admin.periods.events.requests.colleges') }}</template>
					<ol class="list-decimal list-outside ml-5">
						<li v-for="college in request.colleges">{{ college.name }}</li>
					</ol>
				</LabeledObject>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.requests.edit', request.id)">
						<template v-if="request.is_pending">
							<i class="fa-solid fa-edit mr-2"/>
							{{ trans('general.edit') }}
						</template>
						<template v-else>
							<i class="fa-solid fa-eye mr-2"/>
							{{ trans('general.view') }}
						</template>
					</Link>
				</template>
			</Card>
		</CardGrid>
		<Pagination :resource="requests"/>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type EventRequest} from '@/Types/Periods/Events/EventRequest'

const props = defineProps<{
	requests:PaginatedModel<EventRequest>,
}>()

const requests:Ref<PaginatedModel<EventRequest>> = ref(props.requests)
</script>